

import React from 'react';

import {Modal, ModalHeader, ModalBody} from 'Components/Modal';

import { asset } from "Services/BaseHelpers";

export default class StandAloneChatModel extends React.Component {
    /**
     * @var state
     */
    state = {
    };

    UserAvatar( user ) {
        if ( user.avatar_path && user.avatar_path.url ) {
            return <img
                src={ user.avatar_path.url }
                alt={ user.name }
                className="w-full h-full object-cover"
            />;
        } else {
            return <img
                src={ asset( '/images/placeholder-profile.png' ) }
                alt={ user.name }
                className="w-full h-full object-cover"
            />;
        }
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {onClose, user} = this.props;

        return (
            <Modal titleClass="text-[#491D8B]" onClose={onClose} className="max-w-screen-sm md:max-w-4xl">
                <ModalHeader onClose={onClose} className="border-none text-[#491D8B]" titleClassName="text-[#491D8B]" />
                <ModalBody>
                    <div className="flex flex-col md:flex-row items-stretch rounded-lg overflow-hidden shadow-sm">
                        {/* Left: image panel */}
                        <div className="w-full md:w-2/5 flex-shrink-0">
                            {this.UserAvatar(user)}
                        </div>

                        {/* Right: content panel */}
                        <div className="w-full md:w-3/5 flex flex-col p-6 justify-between" style={{ background: '#E8DAFF' }}>
                            <div>
                                <h2 className="text-xl font-bold leading-tight mb-4" style={{ color: '#491D8B' }}>
                                    {user.name}
                                </h2>

                                {user.job_title && (
                                    <p className="text-sm mb-1" style={{ color: '#491D8B' }}>{user.job_title}</p>
                                )}

                                {user.company_name && (
                                    <p className="text-sm font-bold mb-1" style={{ color: '#491D8B' }}>{user.company_name}</p>
                                )}

                                {user.email && (
                                    <p className="text-sm mb-1" style={{ color: '#491D8B' }}>
                                        <a href={"mailto:" + user.email} className="underline">{user.email}</a>
                                    </p>
                                )}

                                {user.linkedin && (
                                    <p className="text-sm mb-1" style={{ color: '#491D8B' }}>
                                        <a href={ user.linkedin } target="_blank" rel="noopener noreferrer" className="underline">
                                            LinkedIn Profile
                                        </a>
                                    </p>
                                )}

                                <p className="text-sm mt-4" style={{ color: '#491D8B' }}>
                                    Attending: <span className="font-bold">
                                        {user.group_name && user.group_name.toLowerCase().includes('virtual') ? 'Virtually' : 'In person'}
                                    </span>
                                </p>
                            </div>

                            <div className="mt-6 flex items-center justify-between">
                                <a
                                    href={"/networking/" + user.id}
                                    onClick={onClose}
                                    className="font-bold cursor-pointer inline-flex items-center text-sm"
                                    style={{ color: '#491D8B' }}
                                >
                                    Connect <span className="ml-1">→</span>
                                </a>

                                <button
                                    onClick={onClose}
                                    className="font-bold cursor-pointer inline-flex items-center text-sm"
                                    style={{ color: '#491D8B' }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }
}
